


























import A01MessageListPanel from "@/general/components/pages/parts/Top/A01MessageListPanel.vue";
import A01PanelHeadingTitle from "@/general/components/pages/parts/Top/A01PanelHeadingTitle.vue";
import TextLink from "@/common/components/atoms/TextLink.vue";
import IconTime from "@/common/components/icons/IconTime.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";

@Component({
  components: {
    A01MessageListPanel,
    A01PanelHeadingTitle,
    TextLink,
    IconTime
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TheA01MessagePanel extends Vue {
  @Prop({ type: Array, required: true }) messages!: any;
  storeColorCode: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get url() {
    return CONST_DATA.SITE_MAP.THANKS_POINT;
  }
}
